import { getHost } from 'helpers/host';
import isClient from 'helpers/isClient';
import { EventsResponse } from 'pages/api/eventsApi.types';

export interface FetchProps {
  domain: string;
  query: string;
}

export interface ApiFetchEventsResponse {
  data: EventsResponse;
}

export const fetchEvents = async ({
  domain,
  query,
}: FetchProps): Promise<ApiFetchEventsResponse> => {
  try {
    const url = `${getHost(domain)}/api/eventsApi${query}`;

    const options = {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
        'cache-control': 'no-cache',
      },
    };

    if (!isClient()) {
      // @ts-ignore
      options.headers.Authorization =
        'Basic ' +
        Buffer.from('ballenberg' + ':' + process.env.BASIC_AUTH_PASSWORD).toString('base64');
    }

    const response = await fetch(url, options);
    return await response.json();
  } catch (error) {
    throw { name: 'APiPrismicError', message: error };
  }
};
